import axios from 'axios'
import {EntityDto} from '../../../../../services/dto/entityDto'
import CreateCardRequest from './dto/CreateCardRequest'
import GetCardRequest from './dto/GetCardRequest'
import UpdateCardRequest from './dto/UpdateCardRequest'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/CardRequest/Create`
export const URL_DELETE = `${API_URL}/CardRequest/Delete`
export const URL_GET = `${API_URL}/CardRequest/Get`
export const URL_GET_ALL = `${API_URL}/CardRequest/GetCardByUserIdAll`
export const URL_UPDATE = `${API_URL}/CardRequest/Update`

export function onCreateCardRequest(createCardRequest: CreateCardRequest): Promise<boolean> {
  return axios.post(URL_CREATE, createCardRequest)
}

export function onDeleteCardRequest(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetCardRequests(): Promise<GetCardRequest[]> {
  return axios.get(URL_GET_ALL)
}
export function onGetCardRequest(entityDto: EntityDto): Promise<GetCardRequest> {
  return axios.get(URL_GET, {params: entityDto})
}
export function onUpdateCardRequest(updateCardRequest: UpdateCardRequest): Promise<boolean> {
  return axios.put(URL_UPDATE, updateCardRequest)
}
